import React, { Component } from 'react';
import './stripe.css';
import './step.css';


function Step2 (props){
  var style="stripe-button";
  // var style="className='stripe-button'";
  if (props.error===true){
    var style="stripe-button stripeError"
      // document.getElementById('stripe-connect-button').classList.add("stripeError");
  }
  return(
    <div id="stripe-connect-button"  className={style}>

    <a href="https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_Au4MGtSULCL7nmQ3n2WJnOKy8Y4fPQqq&scope=read_write" className="stripe-connect"><span>Connect with Stripe</span></a>

      <h2 className="stepNumber">Step 2 of 3</h2>
      </div>
)
}






export default Step2;



// WEBPACK FOOTER //
// ./src/step2.js